var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":!_vm.$vuetify.breakpoint.mobile}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"md":"8","cols":"12","offset-md":"2"}},[_c('Tarifs')],1)],1),_c('Reservation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }